export const validateRequiredText = (text?: string): boolean => {
  return text ? Boolean(text.trim()) : Boolean(text);
};
